/**
 * v1.6.448 — App version constant.
 *
 * Source of truth: package.json `version`. Bumped in lockstep with
 * package.json on every release.
 *
 * GENERATED FILE — do not edit by hand. Regenerated by update-version.sh
 * on every `npm run prebuild`. Hand-edits will be overwritten.
 *
 * Surfaced in the sidebar footer so the operator can read off the
 * deployed version when triaging a "is this fix actually live?"
 * question without needing DevTools or a backend trace.
 *
 * The drift-detection spec (app-version.spec.ts) fails CI when this
 * disagrees with package.json — kept as a safety net for the case
 * where tests run outside the build pipeline.
 */
export const APP_VERSION = '1.6.1842';
